export type MediaCoverageArticle = {
  headline: string;
  source: string;
  dateLabel: string;
  imageSrc: string;
  imageAlt: string;
  topic?: string;
};

/** Featured hero article */
export const featuredArticle: MediaCoverageArticle = {
  headline:
    'Sunsure Energy signs 3 consecutive PPAs with Wonder Cement; delivering 30 MWp across Maharashtra & UP',
  source: 'Tribune India',
  dateLabel: 'Apr 7, 2026',
  imageSrc: '/images/guikd_424.png',
  imageAlt: 'Wonder Cement and partners at a media event',
  topic: 'Energy',
};

/** Grid articles — each includes a fallback image */
export const gridArticles: MediaCoverageArticle[] = [
  {
    headline: 'CareEdge Ratings reaffirms CARE AA; Stable rating for Wonder Cement Limited',
    source: 'CareEdge Ratings',
    dateLabel: 'Dec 18, 2025',
    imageSrc: '/images/stand_img1.jpg',
    imageAlt: 'Wonder Cement receives CARE AA stable rating',
    topic: 'Finance',
  },
  {
    headline:
      'Wonder Cement secures title sponsorship rights for highly awaited India tour of South Africa',
    source: 'Business Standard',
    dateLabel: 'Dec 18, 2025',
    imageSrc: '/images/hm_blog1.jpg',
    imageAlt: 'Wonder Cement sponsors India tour of South Africa',
    topic: 'Sports',
  },
  {
    headline: 'Wonder Cement secures title sponsorship rights for India - Sri Lanka series',
    source: 'Business Standard',
    dateLabel: 'Jul 23, 2024',
    imageSrc: '/images/hm_blog2.jpg',
    imageAlt: 'Wonder Cement sponsors India Sri Lanka cricket series',
    topic: 'Sports',
  },
  {
    headline: 'BCCI onboards Wonder Cement as official umpire partner for IPL',
    source: 'BestMediaInfo',
    dateLabel: 'Jul 23, 2024',
    imageSrc: '/images/video_gl.jpg',
    imageAlt: 'BCCI and Wonder Cement IPL umpire partnership',
    topic: 'Sports',
  },
  {
    headline:
      "Wonder Cement's 'Farq Nazar Aayega' campaign becomes reality: accelerating production capacity step by step",
    source: 'Business Today',
    dateLabel: 'Jan 8, 2024',
    imageSrc: '/images/opc_bg.jpg',
    imageAlt: 'Wonder Cement Farq Nazar Aayega campaign',
    topic: 'Marketing',
  },
];
